<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-course`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M40 4a2 2 0 012 2v37a2 2 0 01-2 2H8a2 2 0 01-2-2V6a2 2 0 012-2h32zm-2 4H27v12.929a2 2 0 01-2.809 1.829L20 20.905l-4.191 1.853A2 2 0 0113 20.928V8h-3v33h28V8zM23 8h-6v9.858l3-1.327 3 1.327V8z"/></svg>
</template>
<script>

export default {
  name: 'IconCourse',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
